import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "setting-format-page" }
const _hoisted_2 = { class: "setting-format-page__header" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "container__label" }
const _hoisted_5 = { class: "container__options" }
const _hoisted_6 = ["value", "checked", "onChange"]
const _hoisted_7 = { class: "container__format-text" }
const _hoisted_8 = { class: "save" }

import {
  loadMyPropertyPreferences,
  myPropertyPreferences,
  saveMyPropertyPreferences,
  outputDateFormatValues,
  OutputDateFormat,
} from '@/appLogic/view/preferences';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { waitLoading } from '@/corePagesModule/components/InfoModal/waitLoading';
import { openFailToSavedModal, openSuccessToSaveModal } from '@/corePagesModule/components/modal/modalActions';
import { i18n } from '@/i18n';
import SettingsPageTitle from '@/settingsModule/components/SettingsPageTitle.vue';
import { onBeforeMount, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingFormatPage',
  setup(__props) {

const t = i18n.t;

const selectedFormat = ref<OutputDateFormat | undefined>(undefined);
const isEdited = ref<boolean>(false);

/**
 * 日付フォーマットを変更した際のハンドラ
 * @param format - 選択された日付フォーマット
 */
const onFormatChange = async (format: OutputDateFormat) => {
  isEdited.value = true;
  selectedFormat.value = format;
};

/**
 * 保存ボタンを押した際の処理
 */
const onSave = async () => {
  if (!selectedFormat.value) return;
  isEdited.value = false;
  myPropertyPreferences.outputDateFormat = selectedFormat.value;
  try {
    const res = await waitLoading(saveMyPropertyPreferences(), t('保存中…'), '');
    if (res == null) throw new Error();
    await openSuccessToSaveModal();
  } catch (e) {
    await openFailToSavedModal();
  }
  location.reload();
};

onBeforeMount(async () => {
  await waitLoading(loadMyPropertyPreferences(), undefined, '');
  selectedFormat.value = myPropertyPreferences.outputDateFormat ?? 'YYYY/MM/DD';
  isEdited.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(SettingsPageTitle, {
        label: _unref(t)('設定 > 出力日付フォーマット')
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('出力時の日付フォーマットを選択してください')), 1),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(outputDateFormatValues), (format) => {
          return (_openBlock(), _createElementBlock("label", {
            key: format,
            class: _normalizeClass(["container__option", { 'container__option--selected': selectedFormat.value === format }])
          }, [
            _createElementVNode("input", {
              type: "radio",
              name: "outputDateFormat",
              value: format,
              checked: selectedFormat.value === format,
              class: "container__radio",
              onChange: ($event: any) => (onFormatChange(format))
            }, null, 40, _hoisted_6),
            _createElementVNode("span", _hoisted_7, _toDisplayString(format), 1)
          ], 2))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", {
          class: _normalizeClass(["save__text", { invisible: !isEdited.value }])
        }, _toDisplayString(_unref(t)('未保存の設定変更があります')), 3),
        _createVNode(TextButton, { onClick: onSave }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('保存する')), 1)
          ], undefined, true),
          _: 1
        })
      ])
    ])
  ]))
}
}

})